<script setup lang="ts">

import PositionIcon from '@/components/Elements/Images/Icons/PositionIcon.vue'
import PlayerName from '@/components/Objects/PlayerName.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Props
 */
const props = defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    data: {
      name: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
      status?: string;
    }
  },
  eta: number
}>();

</script>

<template>
  <StandardCard top-padding="0" bottom-padding="1">
    <div class="flex justify-between text-subtext w-full">
      <div class="flex flex-wrap gap-4">
        <GenericIcon :tooltip="t('command.ships.current.follow.tooltip')" type="cmd_follow" class="hidden md:inline"/>
        <div class="flex flex-wrap items-center">
          <div class="me-1">
            {{ t('command.ships.current.follow.follow') }} <PlayerName :playerId="shipActionData.targetPlayer" /> {{ t('command.ships.current.follow.to') }}
            <span>{{ shipActionData.data.name }}</span>
          </div>
          <PositionIcon class="pr-1" :x="props.shipActionData.targetX" :y="props.shipActionData.targetY" />
          <span v-if="props.shipActionData.data.status === 'tracking'">{{ t('command.ships.current.follow.tracking') }}</span>
          <span v-if="props.shipActionData.data.status === 'on_position'">{{ t('command.ships.current.follow.caughtUp') }}</span>
          <span v-if="props.shipActionData.data.status === 'lost_tracking'">{{ t('command.ships.current.follow.lostTracking') }}</span>
        </div>
      </div>
      <div class="flex-shrink-0 ps-2">
        {{ eta >= 500 ? '500+' : eta }} {{ t('command.ships.current.days') }}
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>